import React, { useEffect, useState, useRef, useCallback } from "react";
import Globe from "react-globe.gl";

const locations = [
  { lat: 40.7128, lng: -74.0060, name: 'New York', clickable: true },
  { lat: 25.7617, lng: -80.1918, name: 'Florida', clickable: false },
  { lat: 30.2672, lng: -97.7431, name: 'Austin', clickable: false },
  { lat: 36.7783, lng: -119.4179, name: 'California', clickable: false }
];

const getRandomLocation = () => {
  return locations[Math.floor(Math.random() * locations.length)];
};

const CustomGlobe = () => {
  const globeEl = useRef();
  const [selectedLocation, setSelectedLocation] = useState(getRandomLocation());
  const [width, setWidth] = useState(window.innerWidth > 768 ? window.innerWidth / 2 : window.innerWidth / 1.1);
  const [height, setHeight] = useState(window.innerWidth > 768 ? 500 : 300);

  useEffect(() => {
    const interval = setInterval(() => {
      setSelectedLocation(getRandomLocation());
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const MAP_CENTER = { lat: 0, lng: 0, altitude: 1.5 };
    globeEl.current.pointOfView(MAP_CENTER, 0);
  }, [globeEl]);

  useEffect(() => {
    const location = {
      lat: selectedLocation.lat,
      lng: selectedLocation.lng,
      altitude: 1.5
    };

    globeEl.current.pointOfView(location, 0);
  }, [selectedLocation]);

  const handleMarkerClick = useCallback((location) => {
    if (location.clickable) {
      alert(`Zooming in on: ${location.name}`);
      // Implement zoom or redirection to the property address here
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth > 768 ? window.innerWidth / 2 : window.innerWidth);
      setHeight(window.innerWidth > 768 ? 500 : 300);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Globe
      ref={globeEl}
      globeImageUrl={"/images/earth-night.jpg"}
      // backgroundImageUrl={"/images/night-sky.png"}
      backgroundColor="rgb(250,250,250)"
      labelsData={[selectedLocation]}
      labelText={"name"}
      labelSize={1.6}
      labelColor={() => "white"}
      labelDotRadius={0.4}
      labelAltitude={0.05}
      onLabelClick={handleMarkerClick}
      markers={locations}
      markerLat="lat"
      markerLng="lng"
      markerTooltip={(d) => d.name}
      width={width}
      height={height}
    />
  );
};

export default CustomGlobe;
